module.exports = __webpack_public_path__ + "img/img5.cb4228d1.png";